module.exports = __webpack_public_path__ + "assets/img/promo-richart.41ef3600.png";